import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Accordion from 'react-bootstrap/Accordion';
import AdminOrganizer from './adminOrganizer/AdminOrganizer';
import AdminAdministrator from './adminAdministrator/AdminAdministrator';

function AdminHome() {
  return (
    <Accordion defaultActiveKey={['0', '1']} alwaysOpen>
      <Accordion.Item eventKey='0'>
        <Accordion.Header>
          <h2>Administratörer</h2>
        </Accordion.Header>
        <Accordion.Body>
          <div>
            <Row>
              <Col>
                <AdminAdministrator />
              </Col>
            </Row>
          </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey='1' className='mt-4'>
        <Accordion.Header>
          <h2>Arrangörer</h2>
        </Accordion.Header>
        <Accordion.Body>
          <div>
            <Row>
              <Col>
                <AdminOrganizer />
              </Col>
            </Row>
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}

export default AdminHome;
